// Configuracao da vitrine publica (tenants.storefront_settings) e contrato das
// paginas de ofertas (get_storefront_offers). Painel e Worker SSR normalizam o
// mesmo jsonb com esta funcao: o banco valida o essencial, a borda nunca confia.
export const STOREFRONT_THEMES = ["claro", "noite", "oceano", "pessego"];
export const STOREFRONT_THEME_LABELS = {
    claro: "Claro",
    noite: "Noite",
    oceano: "Oceano",
    pessego: "Pêssego",
};
export const STOREFRONT_THEME_PALETTES = {
    claro: { bg: "#f7f7f5", surface: "#ffffff", text: "#17181a", muted: "#5f646b", border: "#e4e4e0", accent: "#1f8a4c", accentInk: "#ffffff" },
    noite: { bg: "#0d0f12", surface: "#171a1f", text: "#f2f4f6", muted: "#9aa3ad", border: "#262a31", accent: "#3ddc84", accentInk: "#0d0f12" },
    oceano: { bg: "#eef5fb", surface: "#ffffff", text: "#0d2438", muted: "#4a6378", border: "#d3e3f0", accent: "#0b6fb8", accentInk: "#ffffff" },
    pessego: { bg: "#fff6f0", surface: "#ffffff", text: "#3a1f12", muted: "#7c5a48", border: "#f4ddcf", accent: "#e8613c", accentInk: "#ffffff" },
};
export const STOREFRONT_SECTIONS = ["todas", "quentes", "hoje", "cupons"];
export const SOCIAL_NETWORKS = ["instagram", "tiktok", "youtube", "facebook", "x", "telegram", "whatsapp"];
export const SOCIAL_LABELS = {
    instagram: "Instagram",
    tiktok: "TikTok",
    youtube: "YouTube",
    facebook: "Facebook",
    x: "X",
    telegram: "Telegram",
    whatsapp: "WhatsApp",
};
export const ITEMS_PER_PAGE_MIN = 1;
export const ITEMS_PER_PAGE_MAX = 100;
export const OFFER_MAX_AGE_DAYS_MIN = 1;
export const OFFER_MAX_AGE_DAYS_MAX = 30;
export const MAX_SETTINGS_TEXT = 160;
export const MAX_NOTICE_TEXT = 300;
export const DEFAULT_AFFILIATE_NOTICE = "Alguns links desta página são de afiliado: posso ganhar uma comissão pelas compras, sem custo extra para você.";
export const DEFAULT_STOREFRONT_SETTINGS = Object.freeze({
    theme: "claro",
    showLogo: true,
    showImages: true,
    showDescriptions: true,
    showSearch: true,
    showCoupons: true,
    itemsPerPage: 24,
    autoOffers: false,
    offerMaxAgeDays: 7,
    invite: Object.freeze({ text: "", buttonText: "Entrar no grupo", url: null }),
    socials: Object.freeze({}),
    affiliateNotice: DEFAULT_AFFILIATE_NOTICE,
});
/** URL publica aceita na vitrine: so https, sem espaco, ate 500 caracteres. */
export function safeHttpsUrl(value) {
    if (typeof value !== "string")
        return null;
    const trimmed = value.trim();
    if (trimmed.length === 0 || trimmed.length > 500 || /\s/.test(trimmed))
        return null;
    try {
        const url = new URL(trimmed);
        return url.protocol === "https:" && url.hostname.length > 0 ? url.toString() : null;
    }
    catch {
        return null;
    }
}
function text(value, fallback, max) {
    if (typeof value !== "string")
        return fallback;
    return value.trim().slice(0, max);
}
function bool(value, fallback) {
    return typeof value === "boolean" ? value : fallback;
}
function clampInt(value, min, max, fallback) {
    if (typeof value !== "number" || !Number.isFinite(value))
        return fallback;
    return Math.min(max, Math.max(min, Math.round(value)));
}
function record(value) {
    return value !== null && typeof value === "object" && !Array.isArray(value) ? value : {};
}
/** Redes sociais validas (so https). Chaves desconhecidas sao descartadas. */
export function normalizeSocialLinks(raw) {
    const r = record(raw);
    const result = {};
    for (const network of SOCIAL_NETWORKS) {
        const url = safeHttpsUrl(r[network]);
        if (url)
            result[network] = url;
    }
    return result;
}
function normalizeInvite(raw) {
    const r = record(raw);
    const d = DEFAULT_STOREFRONT_SETTINGS.invite;
    const buttonText = text(r["buttonText"], d.buttonText, 40);
    return {
        text: text(r["text"], d.text, MAX_SETTINGS_TEXT),
        buttonText: buttonText.length > 0 ? buttonText : d.buttonText,
        url: safeHttpsUrl(r["url"]),
    };
}
/** Normaliza o jsonb cru com defaults seguros (nunca lanca). */
export function normalizeStorefrontSettings(raw) {
    const r = record(raw);
    const d = DEFAULT_STOREFRONT_SETTINGS;
    const theme = STOREFRONT_THEMES.includes(r["theme"]) ? r["theme"] : d.theme;
    const notice = text(r["affiliateNotice"], d.affiliateNotice, MAX_NOTICE_TEXT);
    return {
        theme,
        showLogo: bool(r["showLogo"], d.showLogo),
        showImages: bool(r["showImages"], d.showImages),
        showDescriptions: bool(r["showDescriptions"], d.showDescriptions),
        showSearch: bool(r["showSearch"], d.showSearch),
        showCoupons: bool(r["showCoupons"], d.showCoupons),
        itemsPerPage: clampInt(r["itemsPerPage"], ITEMS_PER_PAGE_MIN, ITEMS_PER_PAGE_MAX, d.itemsPerPage),
        autoOffers: bool(r["autoOffers"], d.autoOffers),
        offerMaxAgeDays: clampInt(r["offerMaxAgeDays"], OFFER_MAX_AGE_DAYS_MIN, OFFER_MAX_AGE_DAYS_MAX, d.offerMaxAgeDays),
        invite: normalizeInvite(r["invite"]),
        socials: normalizeSocialLinks(r["socials"]),
        affiliateNotice: notice.length > 0 ? notice : d.affiliateNotice,
    };
}
export function isStorefrontSection(value) {
    return STOREFRONT_SECTIONS.includes(value);
}
/** Total de paginas (>= 1). */
export function pageCount(total, perPage) {
    return Math.max(1, Math.ceil(Math.max(0, total) / Math.max(1, perPage)));
}
//# sourceMappingURL=storefront-settings.js.map